'use client';

import { useRouter } from 'next/navigation';

import { Section } from '~/components';
import { Typography } from '@bgzt/ui';
import { goToFullWebviewOnApp } from '~/services/app-interface';
import { useEnvironmentInfo } from '~/hooks';

import SearchIcon from './search.svg';

import styles from './searcher.module.css';

export const Searcher = () => {
  const router = useRouter();
  const { isWebview } = useEnvironmentInfo();

  return (
    <Section>
      <button
        className={styles.container}
        onClick={() => {
          if (isWebview) {
            goToFullWebviewOnApp({ url: globalThis.window.location.origin + '/search' }).go();

            return;
          }

          router.push('/search');
        }}
      >
        <SearchIcon className={styles.icon} />
        <Typography variant="L6" color="gray-500">
          어떤 메루카리 상품을 찾고 있나요?
        </Typography>
      </button>
    </Section>
  );
};
